// extracted by mini-css-extract-plugin
export default {"message-container":"Message_message-container__Qd33F","message-info":"Message_message-info__PjDo4","delete-icon":"Message_delete-icon__u1Jf5"};